import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SharedFunctions } from '../../../shared/shared.functions';
import { Router } from '@angular/router';
import { LocalStorageKeys, MenuFuncionCodes, SearchComunidadItemDto, SearchComunidadRequest } from '../../../../../src/app/shared/model';
import { ComunidadService, MenuFuncionService } from '../../../../../src/app/shared/services';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-card-comunidades',
  templateUrl: './card-comunidades.component.html',
  styleUrls: ['./card-comunidades.component.scss']
})
export class CardComunidadesComponent implements OnInit ,OnDestroy  {
  comunidadList: SearchComunidadItemDto[];

  canViewComunidad: boolean = false;
  canAddComunidad: boolean = false;
  canView: boolean = false;
  isValidating: boolean = false;
  isSearching: boolean = false;
  isComunidadSearching: boolean = false;

  private subscription: Subscription;

  constructor(
    private menuService: MenuFuncionService,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    public dialog: MatDialog,
    private comunidadService: ComunidadService,
    private eventEmitterService: EventEmiterService

  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
   }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.DASHBOARD_COMUNIDAD_HOME).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  loadView() {
    this.getComunidades();

    this.menuService.checkMenuPadre(MenuFuncionCodes.COMUNIDAD).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success) {
        this.canViewComunidad = (data?.Result != null && data?.Result.length > 0);
        this.canAddComunidad = (data?.Result != null && data?.Result.some(f => f == MenuFuncionCodes.COMUNIDAD_ADD));
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  verDetalle(id: number) {
    if (id > 0 && this.canViewComunidad)
      this.router.navigate(['/comunidad-edit/'+ id]);
  }

  addComunidad() {
    if (this.canAddComunidad)
      this.router.navigate(['comunidad-edit', 0]);
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }
}
